export const validTrip = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "trip_name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:ADDITIONAL_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    default:
      break;
  }
  return error;
};
